import FaqBlock from "@/components/site/FaqBlock";
import { faqSchema } from "@/lib/schema";
import { Helmet } from "react-helmet-async";
import { useReveal } from "@/hooks/useReveal";

export const HOMEPAGE_FAQS = [
  {
    q: "How much does towing cost?",
    a: "Standard sedans start at $195 for the hook-up plus $5 per mile. Luxury and premium vehicles (Porsche, Mercedes, BMW M, exotics) start at $230 hook-up plus mileage. Every job is quoted on the phone before we roll — no hidden fees.",
  },
  {
    q: "How quickly can you arrive?",
    a: "It depends on traffic, weather, and where you are on the Eastside. We give you an honest ETA on the phone before we dispatch — never a vague 'someone's on the way.'",
  },
  {
    q: "Do you offer flatbed towing?",
    a: "Yes. Flatbed is our default for luxury vehicles, AWD/4WD (so we don't damage the drivetrain), low-clearance sports cars, exotics, and long-distance transport.",
  },
  {
    q: "Are you available 24/7?",
    a: "Yes — every hour of every day, including weekends and holidays. Real people answer the phone. Call (425) 647-9585 anytime.",
  },
  {
    q: "Which cities do you serve?",
    a: "We're based in Kirkland and serve Bellevue, Kirkland, Redmond, Issaquah, Mercer Island, Newcastle, and Sammamish — plus surrounding neighborhoods and the I-405, I-90, SR-520 corridors.",
  },
  {
    q: "What services do you offer besides towing?",
    a: "24/7 emergency towing, flatbed transport, roadside assistance, jump starts, car lockouts, and flat tire changes. If it involves getting you back on the road, we do it.",
  },
];

export default function HomeFaq() {
  const schema = faqSchema(HOMEPAGE_FAQS);
  const headRef = useReveal();
  return (
    <section id="faq" className="relative bg-black py-24 sm:py-32 border-t border-white/5 overflow-hidden">
      <Helmet>
        {schema && (
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        )}
      </Helmet>
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(250,204,21,0.10) 0%, rgba(0,0,0,0) 55%)" }}
      />
      <div className="pointer-events-none absolute inset-0 bm-grain" />

      <div ref={headRef} className="lux-reveal relative max-w-4xl mx-auto px-4 sm:px-6">
        <div className="font-display uppercase tracking-[0.32em] text-yellow-400 text-xs flex items-center gap-2">
          <span className="inline-block h-1.5 w-6 bg-yellow-400 rounded-full" />
          Frequently Asked
        </div>
        <h2 className="mt-3 font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
          Common questions about towing <span className="text-yellow-400">on the Eastside.</span>
        </h2>
        <p className="mt-5 text-zinc-400 text-base sm:text-lg font-light leading-relaxed">
          The questions we get asked most, answered honestly. If yours isn't here — call us. We're always happy to talk it through.
        </p>
        <div className="mt-10 lux-glass-strong rounded-2xl overflow-hidden">
          <FaqBlock faqs={HOMEPAGE_FAQS} testId="home-faq" />
        </div>
      </div>
    </section>
  );
}
